import { MercadoCard } from "../components/ticker/MercadoCard";
import { AreasConfig } from "../components/exp/AreasConfig";
import { EwsConfig } from "../components/kit/Respaldos";
import { AiConfig } from "../components/kit/AiConfig";
import { CapAprobadores } from "../components/captacion/CapAprobadores";
import { CnbvMapeos } from "./ReportesCnbv";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "../lib/api";
import { can, useAuth } from "../lib/auth";
import { Btn, Card } from "../components/kit/Kit";
import { Parametros } from "../components/riesgo/Parametros";
import { Fuentes } from "../components/riesgo/MapaRiesgo";
import { ProgramaConfig } from "./Programa";
import { Ajustes, Laboratorio, Simulador } from "./RiskEngine";

export const esConfig = (u) => ["master", "admin"].includes(u?.template) || can(u, "risk.configurar");

const FuentesTab = () => {
  const [f, setF] = useState(null);
  const load = () => http.get("/riesgo/regional?nivel=estado").then((r) => setF(r.data.fuentes));
  useEffect(() => { load(); }, []);
  return <div className="space-y-6">{f && <Fuentes fuentes={f} onReload={load} />}<Parametros seccion="fuentes" /></div>;
};

const CotDefaults = () => {
  const [c, setC] = useState(null);
  useEffect(() => { http.get("/cotizador/config").then((r) => setC(r.data)); }, []);
  if (!c) return null;
  const save = async () => { try { setC((await http.put("/cotizador/config", c)).data); toast.success("Valores del cotizador guardados"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card title="Cotizador: valores por defecto" subtitle="Tasa, comisión y plazo sugeridos; tasa mínima para referenciadores" testid="cfg-cotizador">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-6">{[["tasa", "Tasa %"], ["comision", "Comisión %"], ["plazo", "Plazo"], ["gracia", "Gracia"], ["bullet", "Bullet %"], ["tasa_min_ref", "Tasa mínima ref. %"]].map(([k, l]) => (
        <label key={k} className="block text-[11px] font-semibold uppercase tracking-widest text-[#8C867A]">{l}<input type="number" step="any" value={c[k]} onChange={(e) => setC({ ...c, [k]: +e.target.value })}
          className="mt-1 w-full rounded-lg border border-[#E2DDD5] bg-[#FAF8F5] px-3 py-2 text-sm" data-testid={`cfg-cot-${k}`} /></label>))}</div>
      <Btn kind="primary" className="mt-3" onClick={save} data-testid="cfg-cot-guardar">Guardar</Btn>
    </Card>
  );
};

const Acceso = () => {
  const [q, setQ] = useState(null);
  useEffect(() => { http.get("/auth/quick-login").then((r) => setQ(r.data)); }, []);
  return q && (
    <Card title="Acceso rápido (temporal)" subtitle="Interruptor global: QUICK_LOGIN_ENABLED en el servidor · la lista se edita en Equipo y permisos → Acceso rápido (Master Admin)" testid="cfg-acceso">
      <p className="text-sm">Estado: <b data-testid="cfg-acceso-estado">{q.enabled ? "ACTIVO" : "Desactivado"}</b>{q.enabled ? ` · ${q.users.length} usuarios en la lista` : ""}</p>
      <ul className="mt-2 text-xs text-[#5C5850]">{q.users.map((u) => <li key={u.id}>{u.name} · {u.puesto}</li>)}</ul>
      <p className="mt-3 text-xs text-[#8C867A]">Para desactivarlo: QUICK_LOGIN_ENABLED=false en backend/.env y reiniciar el backend. Cada acceso queda en Equipo → Auditoría.</p>
    </Card>
  );
};

const TABS = [["inst", "Parámetros institucionales"], ["limites", "Límites de concentración"], ["vigencia", "Vigencia de documentos"], ["pesos", "Pesos del índice regional"],
  ["fuentes", "Fuentes de datos y plantillas"], ["comisiones", "Comisiones"], ["validacion", "Validación del motor"], ["cnbv", "CNBV"], ["acceso", "Acceso rápido"]];
const ADMIN_TABS = [["captacion", "Captación"], ["ews", "Alertas tempranas"], ["ai", "Trafalgar AI"], ["expedientes", "Expedientes"], ["integraciones", "Integraciones"]];

export default function Configuracion() {
  const [tab, setTab] = useState(new URLSearchParams(window.location.search).get("tab") || "inst");
  const { user } = useAuth();
  const tabs = ["master", "admin"].includes(user?.template) ? [...TABS, ...ADMIN_TABS] : TABS;
  return (
    <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10" data-testid="configuracion-page">
      <div><p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C867A]">Master Admin · Administradores</p>
        <h1 className="font-serif-display text-4xl font-bold sm:text-5xl">Configuración<span className="text-[#E8643C]">.</span></h1></div>
      <div className="no-scrollbar flex gap-1 overflow-x-auto rounded-xl border border-[#E2DDD5] bg-white p-1" data-testid="cfg-tabs">{tabs.map(([k, l]) => (
        <button key={k} onClick={() => setTab(k)} data-testid={`cfg-tab-${k}`} className={`shrink-0 rounded-lg px-4 py-1.5 text-sm font-medium transition-colors ${tab === k ? "bg-[#111] text-white" : "text-[#5C5850] hover:bg-[#F2F0EC]"}`}>{l}</button>))}</div>
      <div key={tab} style={{ animation: "rise .25s ease-out both" }}>
        {["inst", "limites", "pesos"].includes(tab) && <Parametros seccion={tab} />}
        {tab === "vigencia" && <Ajustes />}
        {tab === "fuentes" && <FuentesTab />}
        {tab === "comisiones" && <div className="space-y-6"><ProgramaConfig /><CotDefaults /><Parametros seccion="comisiones" /></div>}
        {tab === "validacion" && <div className="space-y-6"><Simulador /><Laboratorio /></div>}
        {tab === "cnbv" && <CnbvMapeos />}
        {tab === "acceso" && <Acceso />}
        {tab === "ai" && <AiConfig />}
        {tab === "ews" && <EwsConfig />}
        {tab === "expedientes" && <AreasConfig />}
        {tab === "captacion" && <CapAprobadores />}
        {tab === "integraciones" && <MercadoCard />}
      </div>
    </main>
  );
}
